import Entity from 'utilities/Entity';

class School extends Entity {}

export default new School();
